export const randomizeStories = (basicStories = []) => {
  return basicStories
    .map(a => [Math.random(), a])
    .sort((a, b) => a[0] - b[0])
    .map(a => a[1]);
};

export const alternatePostsAndStories = (basicStories = [], posts = [], limit = 1) => {
  let alternatePosts = posts
    .map((story, index) =>
      index > 0 && index % 3 === 0 && basicStories.length > 0
        ? [story, basicStories.splice(0, 1)[0]]
        : story)
    .flat();

  if (alternatePosts.length < limit) {
    alternatePosts = alternatePosts.concat(basicStories);
  }
  return alternatePosts;
};
